import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { leadConnectionReducer } from "../../redux/slices/leadConnection";
import { leadDebugReducer } from "../../redux/slices/leadDebug";
import { leadHistoryReducer } from "../../redux/slices/leadHistory";
import { retryLeadHistoryAsync } from "../../redux/slices/leadHistory/leadHistory.asyncActions";
import {
    getConnectionDetailAsync,
    getDebugModeResultsAsync,
    setDebugModeAsync,
} from "../../redux/slices/leadDebug/leadDebug.asyncActions";
import {
    clearLeadDebug,
    hydrateConnectionDetail,
    setSelectedLogId,
} from "../../redux/slices/leadDebug/leadDebug.slice";
import LeadDebugPage from "./LeadDebugPage.layout";
import {
    LeadDebugPageDispatchProps,
    LeadDebugPageStateProps,
} from "./LeadDebugPage.types";

const selectCachedConnection = (state: any) => {
    const cached =
        state[leadConnectionReducer].getAllLeadConnection.singleConnection;
    return !cached || Array.isArray(cached) ? null : cached;
};

const mapStateToProps = (state: any): LeadDebugPageStateProps => ({
    connectionDetail: state[leadDebugReducer].connectionDetail,
    singleConnection: selectCachedConnection(state),
    connectionLoading: state[leadDebugReducer].connectionLoading,
    debugLogs: state[leadDebugReducer].debugLogs,
    logsLoading: state[leadDebugReducer].logsLoading,
    pagination: state[leadDebugReducer].pagination,
    selectedLogId: state[leadDebugReducer].selectedLogId,
    setDebugModeLoading: state[leadDebugReducer].setDebugModeLoading,
    isRetryLoading: state[leadHistoryReducer].isRetryLoading,
    retryingStatId: state[leadHistoryReducer].retryingStatId,
});

const mapDispatchToProps = (dispatch: any): LeadDebugPageDispatchProps => ({
    dispatchGetConnectionDetail: (connectionId) =>
        dispatch(getConnectionDetailAsync(connectionId)),
    dispatchGetDebugModeResults: (payload) =>
        dispatch(getDebugModeResultsAsync(payload)),
    dispatchSetDebugMode: (payload) => dispatch(setDebugModeAsync(payload)),
    dispatchClearLeadDebug: () => dispatch(clearLeadDebug()),
    dispatchHydrateConnectionDetail: (detail) =>
        dispatch(hydrateConnectionDetail(detail)),
    dispatchSetSelectedLogId: (logId) => dispatch(setSelectedLogId(logId)),
    dispatchRetryLeadHistory: (payload) =>
        dispatch(retryLeadHistoryAsync(payload)),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LeadDebugPage);
